/* The chooser on the floor and table collection pages (21 Sep 2026, Josh's brief).

   Three questions decide the light: the beam, power, and how the brightness is
   controlled. A fourth, optional, only shapes the set-up note on the result. A fifth,
   on every quiz since 24 Sep 2026 (Josh: always five), asks floor or table and picks
   that format's product (model(id, format)). The
   dialog's markup and every visible word of the questions live in
   sections/v4-collection-cat-chooser.liquid; this script moves between the steps,
   keeps the answers in memory (nothing is sent anywhere), and writes the result.

   The picking rule, in order:
     battery or remote wanted                                  -> HD Pro
     beam to be shaped or concentrated, or a thumbwheel wanted -> HD Original
     unsure about the beam or the control                      -> compare Essential and Original
     otherwise                                                 -> HD Essential

   The result shows: best fit, why it fits you, what you get, what to know, why not the
   other two, the set-up note, the trial and warranty line, the button, the phone.
   Model names, prices, pictures and links come from the range section's data. */
(function () {
  var arrow = '<span class="arrow" aria-hidden="true">&#8594;</span>';
  var PHONE = '0800 032 9366';

  var rangeModels = (function () {
    try {
      return Array.prototype.map.call(document.querySelectorAll('script[data-range-model]'), function (el) { return JSON.parse(el.textContent); });
    } catch (e) { return []; }
  })();
  /* Each light can be published twice, floor and table (24 Sep 2026: every quiz asks where the light will stand), so
     the answer picks the right product; a page that publishes one format still finds its light. */
  function model(id, format) {
    var hit = format ? rangeModels.find(function (m) { return m.id === id && m.format === format; }) : null;
    return hit || rangeModels.find(function (m) { return m.id === id; }) || missing(id, format);
  }
  /* A light the page does not publish at all (unpublished, say) used to give a Choose button that went nowhere ('#').
     It now names the light and sends the visitor to the floor or table lights instead (coverage audit, 25 Sep 2026). */
  function missing(id, format) {
    var names = { essential: 'HD Essential', original: 'HD Original', pro: 'HD Pro' };
    return { id: id, name: names[id] || 'right light', url: format === 'table' ? '/collections/table-lights' : '/collections/floor-lights', price: '', image: '', missing: true };
  }
  function escapeAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function picture(m, format) {
    if (!m.image) return '';
    return '<img src="' + escapeAttr(m.image) + '" alt="' + escapeAttr(m.name + ' ' + format + ' light') + '" width="1500" height="1500" loading="lazy" decoding="async">';
  }
  // The price is an offer slot (snippets/v4-offer-display.liquid): a code holder sees the offer figure, and the "From"
  // word shows or hides with it. m.handle comes from the range data.
  function price(m) { return '<span data-sr-from' + (m.id === 'pro' ? '' : ' hidden') + '>From </span><strong data-sr-fig>' + m.price + '</strong>'; }

  /* Use opens the chooser (Josh, 21 Sep): it only shapes the set-up note and can be skipped. */
  var questions = (function () {
    // Read the questions off the page, so a template can ask one more (the model category
    // pages ask floor or table). A page whose steps carry no id keeps the original four.
    var steps = document.querySelectorAll('[data-quiz-step][data-quiz-id]');
    if (!steps.length) {
      return [
        { id: 'activity', short: 'Use', optional: true },
        { id: 'beam', short: 'Beam' },
        { id: 'power', short: 'Power' },
        { id: 'control', short: 'Controls' }
      ];
    }
    return Array.prototype.map.call(steps, function (el) {
      return {
        id: el.dataset.quizId,
        short: el.dataset.quizShort || el.dataset.quizId,
        optional: el.hasAttribute('data-quiz-optional')
      };
    });
  })();
  var required = questions.filter(function (q) { return !q.optional; });
  var state = { step: 0, answers: {}, opener: null };

  function recommendation(a) {
    if (a.power === 'battery' || a.control === 'remote') return ['pro'];
    if (a.beam === 'adjust' || a.beam === 'focus' || a.control === 'wheel') return ['original'];
    if (a.beam === 'unsure' || a.control === 'unsure') return ['essential', 'original'];
    return ['essential'];
  }

  /* What each light gives you, as the customer would list it. Only verified facts. */
  function getList(id, format, short) {
    var floor = format === 'floor';
    var lists = {
      // Bases (Josh, 22 Sep): the HD Essential and the HD Original come with the Heavyweight or the
      // Lightweight base; the HD Pro has one base.
      essential: ['Daylight Wavelength Technology™', 'Wide fixed beam', 'Press-and-hold dimming that remembers your setting', 'Simpler controls', 'Best value in the core range', 'Heavyweight or Lightweight base', 'Five-year warranty', '30-day home trial'],
      original: ['Daylight Wavelength Technology™', 'Shapeable beam', 'Thumbwheel brightness control that remembers your setting', 'More light on your page when the beam is narrowed', 'Heavyweight or Lightweight base', 'Five-year warranty', '90-day home trial'],
      pro: ['Daylight Wavelength Technology™', 'Shapeable beam', 'Thumbwheel brightness control', 'Optional remote handset', 'Optional battery', 'Five-year warranty', '90-day home trial']
    };
    var list = lists[id];
    if (short) list = list.filter(function (line) { return !/Daylight|Five-year|value/.test(line); });
    return '<ul class="cat-quiz-get">' + list.map(function (line) { return '<li>' + line + '</li>'; }).join('') + '</ul>';
  }

  function toKnow(id, format) {
    if (id === 'essential') return 'The beam width is fixed and it needs a socket.';
    if (id === 'original') return 'It needs a socket and does not offer the HD Pro’s remote or battery options.';
    return 'The price shown is for mains power. The battery and the remote handset are extras and add to the price.';
  }

  function whyItFits(id, a) {
    if (id === 'pro') {
      var both = a.power === 'battery' && a.control === 'remote';
      var line = both ? 'You want to use your light away from a socket and change the brightness from your chair. Only the HD Pro offers both.'
        : a.power === 'battery' ? 'You want to use your light away from a socket. The battery option is only on the HD Pro.'
        : 'You want to change the brightness from your chair. The remote handset is only on the HD Pro.';
      if (a.beam === 'adjust' || a.beam === 'focus') line += ' It shapes the beam as well.';
      return line;
    }
    if (id === 'original') {
      if ((a.beam === 'adjust' || a.beam === 'focus') && a.control === 'wheel') return 'You want to change the width of the beam and set the brightness with a thumbwheel. The HD Original gives you both.';
      if (a.beam === 'adjust') return 'You want to make the beam wider or narrower. The HD Original does that with a ring on the head, and its thumbwheel sets the brightness.';
      if (a.beam === 'focus') return 'You want more light concentrated on a smaller area. Narrowing the HD Original’s beam does exactly that.';
      return 'You prefer a thumbwheel for the brightness. The HD Original has one, and lets you shape the beam as well.';
    }
    var essential = 'You want a wide beam and straightforward brightness control, and you do not need battery power, a remote or beam adjustment. The HD Essential is that light.';
    if (a.power === 'move') essential += ' It plugs in, so check there is a socket wherever you will use it.';
    return essential;
  }

  function whyNotOthers(ids, a) {
    var declined = a.control === 'unsure' || a.power === 'move';
    var proLine = declined ? 'adds remote and battery options you have not asked for.' : 'adds remote and battery options that you said you do not need.';
    var lines;
    if (ids.length > 1) lines = [['HD Pro', proLine]];
    else if (ids[0] === 'original') lines = [['HD Essential', 'simpler, but its beam width is fixed.'], ['HD Pro', proLine]];
    else if (ids[0] === 'essential') lines = [['HD Original', 'adds a shapeable beam and a thumbwheel, which you said you do not need.'], ['HD Pro', proLine]];
    else lines = [['HD Original', 'the same shapeable beam and thumbwheel, but no battery or remote.'], ['HD Essential', 'a fixed wide beam, with no battery or remote.']];
    return '<div class="cat-quiz-others"><h4>' + (ids.length > 1 ? 'Why not the HD Pro?' : 'Why not the other two?') + '</h4>' +
      lines.map(function (l) { return '<p><strong>' + l[0] + ':</strong> ' + l[1] + '</p>'; }).join('') + '</div>';
  }

  function setupNote(a) {
    var notes = {
      reading: 'Stand the light beside or behind your chair and bring the head over your shoulder, so the light falls on your book and not in your eyes.',
      sewing: 'Bring the head in close over your work and angle it so your hands do not cast a shadow across the stitches.',
      making: 'Set the head above and a little in front of your work, so the colours are lit evenly and your hand does not shadow the detail.',
      mix: 'Put the base where you can swing the head between your chair and your work without moving the light.'
    };
    var note = notes[a.activity];
    if (!note) return '';
    if (a.power === 'move') note += ' If you will move it often, compare the base weights on the product page.';
    return '<div class="cat-quiz-setup"><h4>When you set it up</h4><p>' + note + '</p></div>';
  }

  function trialLine(id) {
    return '<p class="cat-quiz-trial">' + (id === 'essential' ? '30 days' : '90 days') + ' at home and a five-year warranty. If it is not right for you, we collect it from a UK mainland address.</p>';
  }

  function buyRow(m, verb) {
    if (m.missing) return '<div class="cat-quiz-buy"><a class="btn gold" href="' + escapeAttr(m.url) + '">See the ' + (/table/.test(m.url) ? 'table' : 'floor') + ' lights ' + arrow + '</a></div>';
    return '<div class="cat-quiz-buy"><p class="cat-price" data-category-price="' + m.id + '" data-sr-price="from" data-handle="' + escapeAttr(m.handle || '') + '" data-sr-p="lux">' + price(m) + ' <s class="sro-was" data-sr-was hidden></s><span class="sro-note" data-sr-note hidden></span></p><a class="btn gold" href="' + escapeAttr(m.url) + '" aria-label="' + verb + ' the ' + escapeAttr(m.name) + '">' + verb + ' the ' + m.name + ' ' + arrow + '</a></div>';
  }

  function result(format, a) {
    var ids = recommendation(a);
    if (ids.length > 1) {
      return '<h3 id="cat-quiz-result-title" tabindex="-1">Compare the HD Essential and the HD Original</h3>' +
        '<p class="cat-quiz-result-intro">You have not settled on the beam or the controls yet. These are the two to weigh up.</p>' +
        '<div class="cat-quiz-recommendations cat-two-recommendations">' + ids.map(function (id) {
          var m = model(id, format);
          var why = id === 'essential' ? 'A wide beam and a press-and-hold button cover a great deal of reading, and it is the simplest of the three.'
            : 'A beam you can narrow for small print or widen for a newspaper, and a thumbwheel for the brightness.';
          return '<article>' + picture(m, format) + '<div><h4>' + m.name + '</h4><h5>Why you might choose it</h5><p>' + why + '</p><h5>What you get</h5>' + getList(id, format, true) + '<h5>What to know</h5><p class="cat-quiz-tradeoff">' + toKnow(id, format) + '</p>' + buyRow(m, 'Choose') + '</div></article>';
        }).join('') + '</div>' +
        whyNotOthers(ids, a) + setupNote(a) +
        '<p class="cat-quiz-advice">You can change any answer above, or talk it through on <a href="tel:' + PHONE.replace(/ /g, '') + '">' + PHONE + '</a>.</p>';
    }
    var id = ids[0], m = model(id, format);
    return '<h3 id="cat-quiz-result-title" tabindex="-1">Best fit: ' + m.name + '</h3>' +
      '<div class="cat-quiz-recommendations"><article>' + picture(m, format) +
        // The price and the button sit right under the reason (Josh, 22 Sep), and again at the end.
        '<div><h5>Why it fits you</h5><p>' + whyItFits(id, a) + '</p>' + buyRow(m, 'Choose') +
        '<h5>What you get</h5>' + getList(id, format, false) +
        '<h5>What to know</h5><p class="cat-quiz-tradeoff">' + toKnow(id, format) + '</p></div>' +
      '</article></div>' +
      whyNotOthers(ids, a) + setupNote(a) + trialLine(id) + buyRow(m, 'Choose') +
      '<p class="cat-quiz-advice">You can change any answer above, or talk it through on <a href="tel:' + PHONE.replace(/ /g, '') + '">' + PHONE + '</a>.</p>';
  }

  function allRequired() { return required.every(function (q) { return state.answers[q.id]; }); }

  function render(focus) {
    var dialog = document.getElementById('category-quiz');
    if (!dialog) return;
    var step = state.step, answers = state.answers, finished = step === questions.length;
    var stage = dialog.querySelector('.cat-quiz-stage'), out = dialog.querySelector('.cat-quiz-result');
    stage.hidden = finished; out.hidden = !finished;
    // Where the light will stand: the visitor's own answer when the page asked for it.
    if (finished) out.innerHTML = result(answers.format || dialog.dataset.quizFormat || 'floor', answers);
    if (finished && window.SROffer) window.SROffer.paint(out);
    dialog.querySelectorAll('[data-quiz-step]').forEach(function (section, index) {
      var active = !finished && index === step;
      section.inert = !active; section.setAttribute('aria-hidden', String(!active));
      section.querySelector('fieldset').disabled = !active;
    });
    dialog.querySelectorAll('[data-quiz-answer]').forEach(function (input) { input.checked = answers[input.dataset.quizAnswer] === input.value; });
    dialog.querySelectorAll('[data-quiz-goto]').forEach(function (button, index) {
      var q = questions[index];
      button.disabled = index !== step && !answers[q.id] && !(q.optional && allRequired());
      button.toggleAttribute('data-complete', Boolean(answers[q.id]));
      if (index === step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
    });
    dialog.querySelector('[data-quiz-status]').textContent = finished ? 'Your recommendation is ready' : 'Question ' + (step + 1) + ' of ' + questions.length;
    var next = dialog.querySelector('[data-quiz-next]'), back = dialog.querySelector('[data-quiz-back]'), skip = dialog.querySelector('[data-quiz-skip]');
    var current = questions[step];
    next.hidden = finished; back.hidden = finished; back.disabled = step === 0;
    next.disabled = !finished && !answers[current.id];
    next.innerHTML = (step === questions.length - 1 ? 'See recommendation' : 'Continue') + ' ' + arrow;
    if (skip) skip.hidden = finished || !(current && current.optional) || Boolean(answers[current.id]);
    dialog.querySelector('[data-quiz-restart]').hidden = !finished;
    dialog.querySelector('[data-quiz-finish]').hidden = !finished;
    if (focus) {
      var target = finished ? out.querySelector('h3') : dialog.querySelector('#cat-question-' + current.id);
      dialog.querySelector('.cat-guide-scroll').scrollTo({ top: 0, behavior: 'instant' });
      if (target) target.focus({ preventScroll: true });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        (finished ? out : dialog.querySelector('[data-quiz-step="' + step + '"]')).animate([{ opacity: .35, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
      }
    }
  }

  function close() {
    var dialog = document.getElementById('category-quiz');
    if (!dialog || !(dialog.open || dialog.hasAttribute('open'))) return;
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    if (state.opener) state.opener.focus({ preventScroll: true });
  }

  document.addEventListener('cancel', function (event) {
    if (event.target.id !== 'category-quiz') return;
    event.preventDefault(); close();
  }, true);
  document.addEventListener('keydown', function (event) {
    var dialog = document.getElementById('category-quiz');
    if (event.key !== 'Tab' || !dialog || !(dialog.open || dialog.hasAttribute('open'))) return;
    var stops = Array.prototype.filter.call(dialog.querySelectorAll('a[href],button,input,summary,[tabindex="0"]'), function (el) { return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert],[hidden]') && el.getClientRects().length; });
    var first = stops[0], last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('change', function (event) {
    var key = event.target.dataset.quizAnswer;
    if (!key) return;
    state.answers[key] = event.target.value;
    var dialog = document.getElementById('category-quiz');
    dialog.querySelector('[data-quiz-next]').disabled = false;
    var skip = dialog.querySelector('[data-quiz-skip]');
    if (skip) skip.hidden = true;
  });
  document.addEventListener('click', function (event) {
    var start = event.target.closest('[data-start-chooser]');
    if (start) {
      var dialog = document.getElementById('category-quiz');
      // A browser without <dialog> (Safari before 15.4): a link keeps its own jump to the chooser on the page (launch audit,
      // 25 Sep 2026); a button, which has nowhere to jump, opens the panel with the open attribute instead, which the
      // closed-panel rule in layout/theme.liquid then stops hiding (full audit round 3, 8 Oct 2026).
      if (!dialog || (typeof dialog.showModal !== 'function' && start.tagName === 'A' && start.getAttribute('href'))) return;
      event.preventDefault();
      state.opener = start;
      render(); if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', ''); render(true); return;
    }
    if (!event.target.closest('#category-quiz')) return;
    if (event.target.closest('[data-quiz-close]')) { close(); return; }
    var goto = event.target.closest('[data-quiz-goto]');
    if (goto && !goto.disabled) state.step = Number(goto.dataset.quizGoto);
    else if (event.target.closest('[data-quiz-next]')) {
      var current = questions[state.step];
      if (!current || !state.answers[current.id]) return;
      state.step = state.step + 1;
    } else if (event.target.closest('[data-quiz-skip]')) {
      var skipping = questions[state.step];
      if (!skipping || !skipping.optional) return;
      state.step = state.step + 1;
    } else if (event.target.closest('[data-quiz-back]')) state.step = Math.max(0, state.step - 1);
    else if (event.target.closest('[data-quiz-restart]')) { state.step = 0; state.answers = {}; }
    else return;
    render(true);
  });
})();
